// extracted by mini-css-extract-plugin
export var typingIndicator = "_rp-0";